import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ComplaintListItem from './complaint-list-item';
import ComplaintDetail from './complaint-detail';
import LoadingState from '../common/loading-state';
// import NewRequestIcon from './new_request_icon.svg';
import NoComplainIcon from './no_complain_icon.svg';
import gaPush from '../../globs/utils/google-analytics';
import config from '../../globs/config';

class Complaint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      showCategoryForm: false,
      isFormSubmitted: false,
      showComplaintDetail: false,
      page: 1,
      selCompType: 'all',
      noDataFound: true,
      hideLoadMore: false,
      yearFilter: [moment().year()],
      selectedYear: moment().year(),
      complaintList:[],
    };
  }

  componentDidMount() {
    const { props } = this;
    const soID = this.props.user.id;
    const fetch_complaints_url = `${config.apiContextPath}/sales_officers/${soID}/businesses/${this.props.match.params.customerId}/complaint_years`;
      props.dataLoad({
        key: 'complaintYears',
        url: fetch_complaints_url,
      });

    this.props.clearComplaints();
    this.fetchComplaintsData();
  }

  componentDidUpdate(prevProps, prevState) {
    // Only update when API status changes from PENDING to complete
    // Prevent infinite loops in React 19
    if (prevProps.ajaxDataLoadStatuses.fetchComplaints === 'PENDING' &&
      this.props.ajaxDataLoadStatuses.fetchComplaints === '') {
      const prevRec = prevProps.complaintList;
      const nextRec = this.props.complaintList;
      console.log(prevProps.complaintList, this.props.complaintList);
      const noDataFound = prevRec.length === nextRec.length;
      const hideLoadMore = prevRec.length === nextRec.length || nextRec.length % 10 !== 0;

      // Only update if state actually needs to change
      if (this.state.showLoader !== false ||
          this.state.noDataFound !== noDataFound ||
          this.state.hideLoadMore !== hideLoadMore) {
        this.setState({
          showLoader: false,
          noDataFound: noDataFound,
          hideLoadMore: hideLoadMore,
        });
        if (prevRec.length === nextRec.length) {
          this.responseDelay();
        }
      }
    }
  }

  onClickCatergoryForm = () => {
    this.fireGaEvent('ContactUs', 'CreateNewRecord', '');
    this.setState({
      showCategoryForm: !this.state.showCategoryForm,
    });
  }

  onHideComplaintDetail = () => {
    this.setState({
      showComplaintDetail: false,
    });
  }

  onClickCategorySelect = () => {
    // this.fireGaEvent('Contact Us', 'Back', 'To List from Select Category');
    this.setState({
      showCategoryForm: !this.state.showCategoryForm,
    });
  }

  onClickComplaintForm = () => {
    // this.fireGaEvent('Contact Us', 'Back', 'To List from New Complaint Form');
    this.setState({
      showComplaintForm: !this.state.showComplaintForm,
    });
  }

  setParentState = (obj) => {
    this.setState({
      complaintForm: {
        ...this.state.complaintForm,
        ...obj,
      },
      showComplaintForm: !this.state.showComplaintForm,
    });
  }

  compTypeChange = (e) => {
    this.fireGaEvent('ContactUs', 'Filter', `Type ${e.target.value}`);
    console.log('event.target.value', e.target.value);
    this.setState({
      selCompType: e.target.value,
      page: 1,
      showLoader: true,
    }, () => {
      this.props.clearComplaints();
      this.fetchComplaintsData();
    });
  }

  yearChange = (e) => {
    this.fireGaEvent('ContactUs', 'Filter', `Year ${e.target.value}`);
    console.log('event.target.value', e.target.value);
    this.setState({
      selectedYear: e.target.value,
      page: 1,
      showLoader: true,
    }, () => {
      this.props.clearComplaints();
      this.fetchComplaintsData();
    });
  }

  fireGaEvent = (act, action, labelIn) => {
    const label = `${labelIn}`;
    gaPush('event', {
      category: act,
      action,
      label,
    });
  };

  fireGaEventPagePath = (path) => {
    gaPush('pageview', {
      path,
    });
  };

  LoadMore = () => {
    // this.fireGaEvent('Contact Us', 'Load More', `Page ${this.state.page + 1}`);
    this.setState({
      page: this.state.page + 1,
      showLoader: true,
    }, () => {
      this.fetchComplaintsData();
    });
  }

  fetchComplaintsData = () => {
    const { props, state } = this;
    const soID = this.props.user.id;
    let path_ = `${config.apiContextPath}/sales_officers/${soID}/businesses/${this.props.match.params.customerId}/complaints?page=${state.page}&year=${state.selectedYear}`;
    // let path_ = `${props.user._links.complaints.href}?page=${state.page}&year=${state.selectedYear}`;
    if (state.selCompType !== 'all') {
      path_ = `${path_}&comp_type=${state.selCompType}`;
    }
    props.dataLoad({
      key: 'fetchComplaints',
      url: path_,
    });

  }

  showDetailComplaint = (complaint) => {
    this.setState({
      showComplaintDetail: true,
      selectedComplaint: complaint,
    });
  }

  responseDelay = () => {
    setTimeout(() => {
      this.setState({
        noDataFound: false,
      });
    }, 5000);
  }

  goBack=()=>{
    this.props.history.push('/customer-list')
  }

  render() {
    const { state, props } = this;
    console.log('props ===>', props.complaintsYear);
    // const compTypes = [...new Set(props.user.complaint_category.map(cat => cat.comp_type))];
    const compTypes = ['complaint','request'];
    const allYears = props.complaintsYear || state.yearFilter;
    // console.log('allYears ===>', allYears);
    return (
      <div className="lr-main lr-main-home zambia-dashboard">
        <div className="contact-us">
          <div className="lr-make-sale lr-overlay">
            <div className="lr-overlay__header">
              <div className="lr-overlay__header-title">
                <button type="button" className="lr-overlay__header-back-button"  >
                  <i className="icon-back" onClick={() => this.goBack() }/>
                </button><span>Contact Us</span>
              </div>
            </div>
            <div className="lr-overlay__body">
              {/* <div className="lr-orders__add-new-order" onClick={this.onClickCatergoryForm}>
                <div className="lr-button lr-button--primary  lr-orders__add-new-order-button new-request-button">
                  <img src={NewRequestIcon} />
                  <span><FormattedMessage id="New.Request.or.Complaint" /></span>
                </div>
              </div> */}
              {
                props.complaintList.length !== 0 &&
                <span className="complaint-allfilters">
                  <div className="complaint-filter">
                    <i className="icon-arrow_down" />
                    <select name="reportNav" id="reportNav" onChange={this.compTypeChange} value={state.selCompType}>
                      <option value="all">All</option>
                      {
                        compTypes.map(type => (
                          <option key={type} value={type}>{`${type[0].toUpperCase() + type.slice(1)}` } </option>
                        ))
                      }
                    </select>
                  </div>
                  <div className="complaint-filter complaint-filter-year">
                    <i className="icon-arrow_down" />
                    <select name="reportNav" id="reportNav" onChange={this.yearChange} value={state.selectedYear}>
                      {
                        allYears.map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))
                      }
                    </select>
                  </div>
                </span>
              }
              {
                  props.complaintList.length > 0 && props.complaintList.map(complaint => (
                  <div className="complaint-list-container" key={complaint.id}>
                    <ComplaintListItem
                      complaint={complaint}
                      showDetailComplaint={this.showDetailComplaint}
                      push={this.props.history.push}
                      customerId={this.props.match.params.customerId}
                    />
                  </div>
                ))
              }
              {
                (!state.hideLoadMore) &&
                <div className="lr-orders__add-new-order">
                  <button
                    className="lr-button lr-button--primary  lr-orders__add-new-order-button"
                    onClick={this.LoadMore}
                  >
                      <span>Load More</span>
                  </button>
                </div>
              }
              {
                props.complaintList.length === 0 && !state.showLoader &&
                <div className="no-complaints">
                  <div className="no-complaints-image">
                    <img src={NoComplainIcon} />
                  </div>
                  <span className="no-complaints-text">
                      <span>No Request or Complaint recorded yet</span>
                      </span>
                </div>
              }
            </div>


            { state.showComplaintDetail &&
              <ComplaintDetail
                complaint={state.selectedComplaint}
                onHideComplaintDetail={this.onHideComplaintDetail}
              />
            }
            {
              state.showLoader &&
              <div>
                <div className="loadingContainer1" />
                <LoadingState />
              </div>
            }
            {
              state.noDataFound && !state.showLoader &&
              <div className="response-information active">
                <div className="flexbox">
                    <span>No data found</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}


Complaint.propTypes = {
  ajaxDataLoadStatuses: PropTypes.shape({
    fetchComplaints: PropTypes.string,
  }),
  complaintList: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  user: PropTypes.shape({
    _links: PropTypes.shape({
      business: PropTypes.shape(),
    }),
  }),
  clearComplaints: PropTypes.func.isRequired,
};

Complaint.defaultProps = {
  user: undefined,
  ajaxDataLoadStatuses: undefined,
};

export default Complaint;
